import { render, staticRenderFns } from "./VTComponent.vue?vue&type=template&id=46c29797&scoped=true"
import script from "./VTComponent.vue?vue&type=script&lang=js"
export * from "./VTComponent.vue?vue&type=script&lang=js"
import style0 from "./VTComponent.vue?vue&type=style&index=0&id=46c29797&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c29797",
  null
  
)

export default component.exports